import { render, staticRenderFns } from "./BrowserDistribution.vue?vue&type=template&id=0a8bb3f0&"
import script from "./BrowserDistribution.vue?vue&type=script&lang=js&"
export * from "./BrowserDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports